// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../demo-rental-history/state/report';
import actions from '../../actions-list';

const updateDemoRentalHistoryReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_DEMO_RENTAL_HISTORY_REPORT_SUCCESS]: updateDemoRentalHistoryReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateDemoRentalHistoryReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/reducers/report.js